import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faLinkedin, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faPhone, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';

function Footer() {
    const currentYear = new Date().getFullYear();
    
    return (
        <footer id="footer" className="text-white py-10" style={{ backgroundColor: 'rgba(0,143,208,255)' }}>
            <div className="container mx-auto px-4">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {/* Columna 1: Logo y descripción */}
                    <div className="flex flex-col items-center md:items-start">
                        <a href="#" className="mb-4">
                            <img
                                src="/assets/footer-logo.png"
                                alt="Lorenzo Vaquer"
                                className="h-20"
                            />
                        </a>
                        <p className="text-gray-100 text-sm md:text-base max-w-xs text-center md:text-left">
                            Más de 50 años brindando soluciones en perforación y bombeo, con compromiso, calidad y excelencia.
                        </p>
                    </div>

                    {/* Columna 2: Enlaces rápidos */}
                    <div className="flex flex-col items-center md:items-start">
                        <h3 className="text-xl font-bold mb-4 border-b-2 border-white inline-block pb-1">Enlaces rápidos</h3>
                        <nav className="flex flex-col space-y-2">
                            <a href="#inicio" className="hover:text-blue-200 transition-colors">Inicio</a>
                            <a href="#nosotros" className="hover:text-blue-200 transition-colors">Nosotros</a>
                            <a href="#servicios" className="hover:text-blue-200 transition-colors">Servicios</a>
                            <a href="#proyectos" className="hover:text-blue-200 transition-colors">Proyectos</a>
                            <a href="#contacto" className="hover:text-blue-200 transition-colors">Contacto</a>
                        </nav>
                    </div>

                    {/* Columna 3: Contacto y redes */}
                    <div className="flex flex-col items-center md:items-start">
                        <h3 className="text-xl font-bold mb-4 border-b-2 border-white inline-block pb-1">Contacto</h3>
                        <ul className="space-y-2 mb-4">
                            <li className="flex items-center">
                                <FontAwesomeIcon icon={faMapMarkerAlt} className="mr-2" />
                                <span>Calle 13 oeste N° 3155, Pocito, San Juan</span>
                            </li>
                            <li className="flex items-center">
                                <FontAwesomeIcon icon={faPhone} className="mr-2" />
                                <a href="tel:02644383030" className="hover:text-blue-200 transition-colors">0264 4383030</a>
                            </li>
                            <li className="flex items-center">
                                <FontAwesomeIcon icon={faEnvelope} className="mr-2" />
                                <a href="mailto:vaquer@vaquerperforaciones.com" className="hover:text-blue-200 transition-colors">
                                    vaquer@vaquerperforaciones.com
                                </a>
                            </li>
                        </ul>

                        {/* Redes sociales */}
                        <div className="flex space-x-4 mt-2">
                            <a href="#" className="text-white hover:text-blue-300 transition-colors">
                                <FontAwesomeIcon icon={faFacebook} size="lg" />
                            </a>
                            <a href="#" className="text-white hover:text-blue-300 transition-colors">
                                <FontAwesomeIcon icon={faInstagram} size="lg" />
                            </a>
                            <a href="#" className="text-white hover:text-blue-300 transition-colors">
                                <FontAwesomeIcon icon={faLinkedin} size="lg" />
                            </a>
                            <a href="https://wa.me/5492644802789" className="text-white hover:text-blue-300 transition-colors">
                                <FontAwesomeIcon icon={faWhatsapp} size="lg" />
                            </a>
                        </div>
                    </div>
                </div>

                {/* Línea divisoria */}
                <div className="border-t border-blue-300 my-6"></div>

                {/* Copyright */}
                <div className="text-center">
                    <p className="text-gray-100">
                        &copy; {currentYear} Lorenzo Vaquer Perforaciones. Todos los derechos reservados.
                    </p>
                    <p className="text-xs text-gray-200 mt-1">
                        Diseñado por <span className="text-red-300">Four Developments</span> en San Juan, Argentina
                    </p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;